<main class="layout mat-typography">
  <h1 class="m3-headline">Page Not Found</h1>
  <div class="image"><img src="/assets/images/404/404.svg" alt="404" width="413" height="224" /></div>
  <h2 class="m3-headline">Grats! You broke it!</h2>
  <p i18n="Error page 404: text [VERIFIED]">The page you were looking for doesn't exist.<br/>
    Don't worry! Go to <a routerLink="/explore">explore page</a> or
    <a href="https://support.corite.com" target="_blank">contact us</a> about a problem.</p>
</main>
